// src/sections/KnowledgeBase.jsx — member-facing Knowledge Base (route /knowledge-base).
// Reads open to every tenant member; the site card and the write affordances appear only for tenant admins
// (canWrite=isTenantAdmin). SA in adminMode is bounced to /admin like other sections.
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext.jsx';
import KnowledgeBaseView from '../context/KnowledgeBaseView.jsx';
import { PAGE_COLUMN } from '../components/ui/SectionCard.jsx';
import PageBand from '../components/ui/PageBand.jsx';
import PersonalizationBadge from '../onboarding/ui/PersonalizationBadge.jsx';

export default function KnowledgeBase() {
  const { t } = useTranslation('context');
  const { activeTenant, isTenantAdmin, isSuperadmin, adminMode, user } = useAuth();

  if (isSuperadmin && adminMode) return <Navigate to="/admin/users" replace />;

  return (
    // 2026-10-01: the same white band as the tenant-admin mount, so a member and an admin see ONE
    // header for the same page. The badge renders nothing for a member (not polled).
    <div>
      <PageBand
        title={t('section.title')}
        aside={<PersonalizationBadge />}
        subtitle={`${t('section.subtitle')}${activeTenant ? ` — ${activeTenant.display_name}` : ''}`}
      />
      <div style={PAGE_COLUMN}>
        <KnowledgeBaseView tenantId={activeTenant?.tenant_id} canWrite={isTenantAdmin} userKey={user?.user_id || user?.email || ''} />
      </div>
    </div>
  );
}
